import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VConsole from 'vconsole';

if (process.env.NODE_ENV === 'production') {
}

// new VConsole()


import 'amfe-flexible';

import { ckEvent } from "../static/js/global";
Vue.prototype.$ckEvent = ckEvent;


import{Image,Icon,Toast,Button,List,Cell,Divider,Field,NavBar,Popup} from 'vant'
Vue.use(Image).use(Icon).use(Toast).use(Button).use(List).use(Cell).use(Divider).use(Field).use(NavBar).use(Popup)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


ckEvent.add("back", () => {
  hdk.binding.runtime.goBack();
});
